import { HttpClient } from "@angular/common/http";
import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Plugins } from "@capacitor/core";
import { ModalController } from "@ionic/angular";
import { cnpj } from "cpf-cnpj-validator";
import { IonicSelectableComponent } from "ionic-selectable";
import { Observable } from "rxjs";
import { Empresa } from "src/app/models/empresa.model";
import { Tipo } from "src/app/models/tipo.model";
import { EmpresasService } from "src/app/services/empresas.service";
import { TiposService } from "src/app/services/tipos.service";

const { Toast, Modals } = Plugins;

declare var Email;
@Component({
  selector: "app-editar-empresa",
  templateUrl: "./editar-empresa.page.html",
  styleUrls: ["./editar-empresa.page.scss"],
})
export class EditarEmpresaPage implements OnInit {
  private tipos$: Observable<Tipo[]>;

  @ViewChild("") elemento: string;
  @ViewChild("pwaphoto") pwaphoto: ElementRef;
  @Input() type: string;
  @Input() empresa: Empresa;

  imgURI: string = null;

  formEmpresa: FormGroup;
  endereco: FormArray;
  categoria: FormArray;
  telefone: FormArray;
  mensagens: any;
  modoEditar: boolean = false;
  estados: Array<any>;
  cidades: any[] = [];
  bancos: Array<any>;

  public tipos: Array<any>;
  public tipoBkp: Tipo[];

  contador_enderecos: any;

  constructor(
    private formBuilder: FormBuilder,
    private empresaService: EmpresasService,
    private modalCtrl: ModalController,
    private tipoService: TiposService,
    private http: HttpClient
  ) {
    this.estados = [];
    this.bancos = [];
    this.tipos$ = this.tipoService.escutarMudancasTipo();
  }

  ngOnInit() {
    this.formulario();
    this.inicializaEstados();
    this.inicializaBancos();
    this.mensagens_validacao();
    this.carregarTipos();
  }

  carregarTipos() {
    this.tipoService.getAll$();
  }
  //fim lista e seleção de Categorias

  formulario() {
    this.formEmpresa = this.formBuilder.group({
      nome_fantasia: new FormControl("", Validators.required),
      cnpj: new FormControl(
        "",
        Validators.compose([Validators.required, Validators.minLength(18)])
      ),
      email: new FormControl(
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$"),
        ])
      ),
      cidade: new FormControl("", Validators.required),
      estado: new FormControl("", Validators.required),
      banco: new FormControl("", Validators.required),
      agencia: new FormControl("", Validators.required),
      conta: new FormControl("", Validators.required),
      celular: new FormControl("", Validators.required),
      telefone: new FormControl(""),
      endereco: new FormControl("", Validators.required),
      logo: new FormControl(""),
      linkGrupo: new FormControl(""),
      origem: new FormControl("Centrais"),
      /* FormArrays */
      categoria: this.formBuilder.array([this.novaCategoria()]),
    });

    if (this.type === "editar") {
      this.modoEditar = true;
      this.formEmpresa
        .get("nome_fantasia")
        .setValue(this.empresa.nome_fantasia);
      this.formEmpresa.get("cnpj").setValue(this.empresa.cnpj);
      this.formEmpresa.get("email").setValue(this.empresa.email);
      this.formEmpresa.get("cidade").setValue(this.empresa.cidade);
      this.formEmpresa.get("estado").setValue(this.empresa.estado);
      this.formEmpresa.get("banco").setValue(this.empresa.banco);
      this.formEmpresa.get("agencia").setValue(this.empresa.agencia);
      this.formEmpresa.get("conta").setValue(this.empresa.conta);
      this.formEmpresa.get("telefone").setValue(this.empresa.telefone);
      this.formEmpresa.get("celular").setValue(this.empresa.celular);
      this.formEmpresa.get("endereco").setValue(this.empresa.endereco);
      this.formEmpresa.get("logo").setValue(this.empresa.logo);
      this.formEmpresa.get("linkGrupo").setValue(this.empresa.linkGrupo);
      this.formEmpresa.setControl(
        "categoria",
        this.recuperarCategoria(this.empresa["categoria"])
      );
    }
  }

  /* ARRAY DE TELEFONES */
  novoTelefone(): FormGroup {
    return this.formBuilder.group({
      telefone: new FormControl("", Validators.required),
    });
  }

  adicionarTelefone(): void {
    this.telefone = this.formEmpresa.get("telefone") as FormArray;
    this.telefone.push(this.novoTelefone());
  }

  removerTelefone(indice) {
    const control = <FormArray>this.formEmpresa.controls.telefone;
    control.removeAt(indice);
  }

  recuperarTelefone(dados: any[]): FormArray {
    const formArray = new FormArray([]);
    dados.forEach((dado) => {
      formArray.push(
        this.formBuilder.group({
          telefone: [dado.telefone],
        })
      );
    });
    return formArray;
  }

  /* ARRAY DE ENDEREÇOS */
  novoEndereco(valor?: any): FormGroup {
    if (valor) {
      return this.formBuilder.group({
        endereco: [valor.endereco],
      });
    } else {
      return this.formBuilder.group({
        endereco: new FormControl(
          "",
          Validators.compose([Validators.required, Validators.minLength(10)])
        ),
      });
    }
  }

  adicionarEndereco(): void {
    this.endereco = this.formEmpresa.get("endereco") as FormArray;
    this.endereco.push(this.novoEndereco());
  }

  removerEndereco(indice) {
    const control = <FormArray>this.formEmpresa.controls.endereco;
    control.removeAt(indice);
  }

  recuperarEndereco(dados: any[]): FormArray {
    const formArray = new FormArray([]);
    dados.forEach((dado) => {
      formArray.push(
        this.formBuilder.group({
          endereco: [dado.endereco],
        })
      );
    });
    return formArray;
  }

  /* ARRAY DE CATEGORIAS */
  testeChange(
    evento: { component: IonicSelectableComponent; value: any },
    index
  ) {
    let categoria = this.formEmpresa.get("categoria") as FormArray;
    this.tipos$.forEach((tipo: any) => {
      if (evento.value == tipo.nomeTipo) {
        categoria
          .at(index)
          .setValue({ categoria: `${tipo.nomeTipo}`, icone: `${tipo.icone}` });
      }
    });
  }

  novaCategoria(): FormGroup {
    return this.formBuilder.group({
      categoria: new FormControl("", Validators.required),
      icone: new FormControl(""),
    });
  }

  adicionarCategoria(): void {
    this.categoria = this.formEmpresa.get("categoria") as FormArray;
    this.categoria.push(this.novaCategoria());
  }

  removerCategoria(indice) {
    const control = <FormArray>this.formEmpresa.controls.categoria;
    control.removeAt(indice);
  }

  recuperarCategoria(dados: any[]): FormArray {
    const formArray = new FormArray([]);
    dados.forEach((dado) => {
      formArray.push(
        this.formBuilder.group({
          categoria: [dado.categoria],
          icone: [dado.icone],
        })
      );
    });
    return formArray;
  }

  editar(empresa: Empresa) {
    const cnpj = empresa.cnpj.toString().replace(/\D/g, "");
    const updatedEmpresa = new Empresa().deserialize({
      ...this.empresa,
      ...empresa,
    });

    this.validarCnpj(cnpj).then(
      async (success) => {
        if (success && success === true) {
          this.empresaService.edit(updatedEmpresa).subscribe(
            async () => {
              await Toast.show({
                text: `${empresa.nome_fantasia} atualizada.`,
                duration: "long",
              });
            },
            async (erro) => {
              await Modals.alert({
                title: "Erro",
                message: `${erro.error.message}`,
              });
            },
            () => {
              this.fecharJanela();
            }
          );
        } else {
          await Toast.show({
            text: "CNPJ inválido! Verifique e tente novamente.",
            duration: "long",
            position: "bottom",
          });
        }
      },
      async (error) => {
        await Modals.alert({
          title: "Erro",
          message: `${error.error.message}`,
        });
      }
    );
  }

  salvar(empresa: Empresa) {
    const cnpj = empresa.cnpj.toString().replace(/\D/g, "");

    this.validarCnpj(cnpj).then(
      async (success) => {
        if (success && success === true) {
          let password = cnpj;
          empresa.password = password;

          this.empresaService.create(empresa).subscribe(
            async () => {
              await Toast.show({
                text: `Nova empresa ${empresa.nome_fantasia} criada.`,
                duration: "long",
              });
              Email.send({
                Host: "smtp.elasticemail.com",
                Username: "cpaixaoneto@gmail.com",
                Password: "CFD74D56E716E83E7049FB4B6EA8485C8569",
                To: empresa.email,
                From: "contato@cartaopass.com.br",
                Subject: "Cadastro Cartão PASS",
                Body: `Sejá bem vindo ao time do Cartão PASS!<br/>
                Acesse a área do parceiro em  http://cartaopass.com.br/<br/>
                Login: ${empresa.email}<br/>
                Senha: ${cnpj}`,
              });
            },
            async (error) => {
              await Modals.alert({
                title: "Erro",
                message: `${error.error.message}`,
              });
            },
            () => {
              this.fecharJanela();
            }
          );
        } else {
          await Toast.show({
            text: "CNPJ inválido! Verifique e tente novamente.",
            duration: "long",
            position: "bottom",
          });
        }
      },
      async (error) => {
        await Modals.alert({
          title: "Erro",
          message: `${error.error.message}`,
        });
      }
    );
  }

  fecharJanela() {
    this.modalCtrl.dismiss({
      dissmissed: true,
    });
  }

  async validarCnpj(aValidar: any) {
    return cnpj.isValid(aValidar);
  }

  async inicializaEstados() {
    fetch("./../../../assets/estados.json")
      .then((dados) => dados.json())
      .then((data) => {
        this.estados = data;
      });
  }

  estadosOnChange(evento: { component: IonicSelectableComponent; value: any }) {
    this.formEmpresa.get("cidade").reset();
    if (evento.value) {
      this.estados.filter((estado) => {
        if (estado.sigla === evento.value) {
          this.cidades = estado.cidades;
        }
      });
    }
  }

  categoriasOnChange(evento: {
    component: IonicSelectableComponent;
    value: any;
  }) {
    if (evento.value) {
      this.estados.filter((tipo) => {
        if (tipo.nomeTipo === evento.value) {
          this.carregarTipos();
        }
      });
    }
  }
  async inicializaBancos() {
    fetch("./../../../assets/bancos.json")
      .then((dados) => dados.json())
      .then((data) => {
        this.bancos = data;
      });
  }

  openPWAPhotoPicker() {
    if (this.pwaphoto == null) {
      return;
    }

    this.pwaphoto.nativeElement.click();
  }

  uploadPWA() {
    if (this.pwaphoto == null) {
      return;
    }

    const fileList: FileList = this.pwaphoto.nativeElement.files;

    if (fileList && fileList.length > 0) {
      this.firstFileToBase64(fileList[0]).then(
        (result: string) => {
          this.imgURI = result;
          this.formEmpresa.get("logo").setValue(this.imgURI);
        },
        (err: any) => {
          // Ignore error, do nothing
          this.imgURI = null;
        }
      );
    }
  }

  private firstFileToBase64(fileImage: File): Promise<{}> {
    return new Promise((resolve, reject) => {
      let fileReader: FileReader = new FileReader();
      if (fileReader && fileImage != null) {
        fileReader.readAsDataURL(fileImage);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };

        fileReader.onerror = (error) => {
          reject(error);
        };
      } else {
        reject(new Error("No file found"));
      }
    });
  }

  mensagens_validacao() {
    this.mensagens = {
      nome_fantasia: [
        {
          type: "required",
          message: "Insira um nome!",
        },
      ],
      cnpj: [
        {
          type: "required",
          message: "Número de CNPJ é obrigatório.",
        },
        {
          type: "minlength",
          message: "Necessário ter 14 dígitos.",
        },
      ],
      email: [
        {
          type: "required",
          message: "Insira um e-mail!",
        },
        {
          type: "pattern",
          message: "Insira um e-mail válido!",
        },
      ],
      telefone: [
        {
          type: "required",
          message: "Número de telefone é obrigatório.",
        },
      ],
      endereco: [
        {
          type: "required",
          message: "Este campo é obrigatório.",
        },
        {
          type: "minlength",
          message: "No mínimo 10 cararteres.",
        },
      ],
      cidade: [
        {
          type: "required",
          message: "Este campo é obrigatório.",
        },
      ],
      estado: [
        {
          type: "required",
          message: "Este campo é obrigatório.",
        },
      ],
    };
  }
}
